<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						api月租充值
					</div>
					<div style="padding: 20px;" class="form">
						<div>
							到期时间：{{user_info.endtime|formatTime}}
						</div>
						<div style="display: flex;align-items: center;margin-top: 20px;flex-wrap: wrap;box-sizing: border-box;justify-content: space-between;" class="form">
							<div v-for="(item,index) in apiChargeConfig" :key="index" class="change-item"
								:class="index==apiChargeIndex?'change-item-active':''" @click="changeApiIndex(index)">
								<span style="font-size: 18px;color: #1919F3;">{{item.title}}</span>
								<div style="display: flex;align-items: flex-end;color: #1919F3;">
									<span style="font-size: 20px;margin-bottom: 4px;">￥</span>
									<span style="font-size: 34px;font-weight: 700;">{{item.price}}</span>
								</div>
								<span
									style="text-decoration:line-through;font-size: 14px;color: #9C9EA7;">原价￥{{item.old_price}}</span>
							</div>
						</div>
						<div style="margin-top: 10px;display: flex;align-items: center;font-size: 14px;">
							<span>支付方式：</span>
							<el-radio-group v-model="api.pay_method" style="margin-top: 3px;">
								<el-radio :label="item.key" v-for="(item,index) in pay_ways"
									:key="index" v-if="item.is_open===1">{{item.title}}</el-radio>
							</el-radio-group>
						</div>
						<div
							style="margin-top: 15px;display: flex;align-items: center;font-size: 14px;justify-content: flex-start;">
							<el-button type="primary" size="small" @click="dopay('api')">确认支付</el-button>
							<el-button type="primary" size="small" @click="openInfo('api')">功能说明</el-button>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box" style="margin-bottom: 20px;">
					<div class="header">
						余额充值
					</div>
					<div style="padding: 20px;" class="form">
						<div style="display: flex;flex-direction: column;">
							<span>当前余额：【{{(user_info.money/100).toFixed(2)}}】元</span>
							<span>用于：发送微信消息，数据系统，营销系统等增值服务消耗。</span>
						</div>
						<div style="margin: 20px 0;">
							<el-input type="number" v-model="wallet.amount" size="small" placeholder="请输入金额" min="0" style="width: 200px;"></el-input>
						</div>
						<div style="margin-top: 10px;display: flex;align-items: center;font-size: 14px;">
							<span>支付方式：</span>
							<el-radio-group v-model="wallet.pay_method" style="margin-top: 3px;" >
								<el-radio :label="item.key" v-for="(item,index) in pay_ways"
									:key="index" v-if="item.is_open==1">{{item.title}}</el-radio>
							</el-radio-group>
						</div>
						<div
							style="margin-top: 15px;display: flex;align-items: center;font-size: 14px;justify-content: flex-start;">
							<el-button type="primary" size="small" @click="dopay('wallet')">确认支付</el-button>
							
						</div>
					</div>
					
				</div>
				<div class="centext-box">
					<div class="header">
						高资源包充值
					</div>
					<div style="padding: 20px;" class="form">
						<div>
							到期时间：{{user_info.high_data_endtime|formatTime}}
						</div>
						<div style="display: flex;align-items: center;margin-top: 20px;flex-wrap: wrap;box-sizing: border-box;justify-content: space-between;" class="form">
							<div v-for="(item,index) in highdataChargeConfig" :key="index" class="change-item"
								:class="index==highdataChargeIndex?'change-item-active':''"
								@click="changeHighdataIndex(index)">
								<span style="font-size: 18px;color: #1919F3;">{{item.title}}</span>
								<div style="display: flex;align-items: flex-end;color: #1919F3;">
									<span style="font-size: 20px;margin-bottom: 4px;">￥</span>
									<span style="font-size: 34px;font-weight: 700;">{{item.price}}</span>
								</div>
								<span
									style="text-decoration:line-through;font-size: 14px;color: #9C9EA7;">原价￥{{item.old_price}}</span>
							</div>
						</div>
						<div style="margin-top: 10px;display: flex;align-items: center;font-size: 14px;">
							<span>支付方式：</span>
							<el-radio-group v-model="highdata.pay_method" style="margin-top: 3px;">
								<el-radio :label="item.key" v-for="(item,index) in pay_ways"
									:key="index" v-if="item.is_open===1">{{item.title}}</el-radio>
							</el-radio-group>
						</div>
						<div
							style="margin-top: 15px;display: flex;align-items: center;font-size: 14px;justify-content: flex-start;">
							<el-button type="primary" size="small" @click="dopay('high_data')">确认支付</el-button>
							<el-button type="primary" size="small" @click="openInfo('high_data')">功能说明</el-button>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="请打开支付宝扫一扫进行支付" :visible.sync="dialogVisible" width="370px" :before-close="beforeClose">
			<div style="display: flex;align-items: center;justify-content: center;">
				<canvas id="qrcode" width="300" height="300"></canvas>
			</div>
		</el-dialog>
		<el-dialog title="信息" :visible.sync="dialogInfoVisible" width="300px">
			<div style="font-size: 14px;margin-bottom: 10px;padding: 5px;">
				{{type==='api'?"卡密登录，用户登录等功能的基础支撑。到期则不能使用这些功能。":'用户配置，卡密配置，数据模块的字节数量扩展，最大字节数量从512扩展为10240。没有用到这些功能则无需充值。'}}</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let interval = null
	import QRCode from 'qrcode'
	import {mapState} from 'vuex'
	export default {
		
		data() {
			return {
				dialogInfoVisible:false,
				type:'api',
				dialogVisible: false,
				input: '',
				pay_method: 'ali',
				user_info: {
					endtime: 0,
					high_data_endtime: 0,
					money: 0
				},
				api: {
					num: 1,
					sub_type: "type_week",
					pay_method: 'ali'
				},
				apiChargeIndex: 0,
				apiChargeConfig: [],
				highdataChargeConfig: [],
				highdataChargeIndex: 0,
				highdata: {
					num: 1,
					sub_type: "type_week",
					pay_method: 'ali'
				},
				wallet:{
					amount:0,
					pay_method:'ali',
				},
				pay_ways: []
			}
		},
		created() {
			this.getData()
		},
		beforeDestroy() {
			if(interval){
				clearInterval(interval)
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		methods: {
			beforeClose(){
				clearInterval(interval);
				interval = null
				this.dialogVisible = false
			},
			openInfo(type){
				this.type = type
				this.dialogInfoVisible = true
			},
			changeHighdataIndex(index) {
				this.highdataChargeIndex = index
				this.highdata.num = this.highdataChargeConfig[index].config_num
				this.highdata.sub_type = this.highdataChargeConfig[index].config_key
			},
			changeApiIndex(index) {
				this.apiChargeIndex = index
				this.api.num = this.apiChargeConfig[index].config_num
				this.api.sub_type = this.apiChargeConfig[index].config_key
			},
			dopay(type) {
				if (type === 'api') {
					let data = {
						type: 'api',
						...this.api
					}
					this.do_pay_real(data)
				} else if(type==='high_data'){
					let data = {
						type: 'high_data',
						...this.highdata
					}
					if (this.user_info.endtime - window.localStorage.getItem('timestamp_'+this.$store.state.user.center_id) < 2592000) {
						this.$confirm('检测到您的api时间不足，请注意，这里是充值高资源包的，具体请查看帮助菜单中内容，如果您要使用本平台的主体功能，那么请充值月租api，不要充值该高资源包，请务必搞明白高资源包的用途之后再充值，以免充错', '请注意', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							showCancelButton:false,
							type: 'warning'
						}).then(() => {
							this.do_pay_real(data)
						}).catch(() => {
							
						});
					} else {
						this.do_pay_real(data);

					}
				}else{
					if(this.wallet.amount<=0){
						return this.$message.error('请输入充值金额')
					}
					let data = {
						...this.wallet
					}
					this.$H.post('quanlang/v1_0_1.User/Charge',data).then(res=>{
						if(res.data){
							console.log(res.data)
							if(interval){
								clearInterval(interval)
							}
							interval = setInterval(()=>{
								this.get_pay_status(res.data.out_trade_no)
							},1000)
							this.dialogVisible = true
							setTimeout(() => {
								let canvas = document.getElementById("qrcode")
								let opts = {
									errorCorrectionLevel: 'H',
									type: "image/png",
									quality: 0.3,
									margin: 5,
									width: 350,
									height: 350,
									text: res.data.qr_code_url,
									color: {
										dark: '#333',
										light: '#fff'
									}
							
								}
								QRCode.toCanvas(canvas, res.data.qr_code_url, opts, (err) => {
									console.log(err)
								})
							}, 500)
						}
					})
				}

			},
			get_pay_status(out_trade_no){
				this.$H.post('common/v1_0_1.Common/OrderStatus',{
					order_id:out_trade_no
				},true).then(order_state => {
					if(order_state.data && order_state.data == 9){
						clearInterval(interval);
						interval = null
						this.$message.success('支付成功')
						this.dialogVisible = false
						this.getData()
					}
				})
			},
			do_pay_real(data) {
				this.$H.post('verify_center/v1_0_1.Mine/Charge', data).then(order_res => {
					if(order_res.data){
						 console.log(order_res.data)
						if(interval){
							clearInterval(interval)
						}
						interval = setInterval(()=>{
							this.get_pay_status(order_res.data.out_trade_no)
						},1000)
						this.pay_method = this.api.pay_method
						this.dialogVisible = true
						setTimeout(() => {
							let canvas = document.getElementById("qrcode")
							let opts = {
								errorCorrectionLevel: 'H',
								type: "image/png",
								quality: 0.3,
								margin: 5,
								width: 350,
								height: 350,
								text: order_res.data.qr_code_url,
								color: {
									dark: '#333',
									light: '#fff'
								}
						
							}
							QRCode.toCanvas(canvas, order_res.data.qr_code_url, opts, (err) => {
								console.log(err)
							})
						}, 500)
					}
					
				})
			},
			getData() {
				//http://bp.2cccc.cc/verify_center/v1_0_1.Config/Get key: "center_highdata_charge_list"
				//http://bp.2cccc.cc/verify_center/v1_0_1.Config/Get key: "pay_method_config"
				//http://bp.2cccc.cc/verify_center/v1_0_1.Mine/CenterInfo
				let fields_arr = ['software_num', 'wechat_info', 'center_id', 'endtime', 'not_read_notice_num', 'money',
					'quanlang_id', 'high_data_endtime', 'is_certify', 'ali_real_name', 'wx_openid'
				]
				this.$H.post('verify_center/v1_0_1.Mine/CenterInfo', {
					fields: fields_arr
				}).then(res => {
					if(res.data){
						this.user_info.endtime = res.data.endtime
						this.user_info.high_data_endtime = res.data.high_data_endtime
						this.user_info.money = res.data.money
					}
				});
				this.$H.post('http://bp.2cccc.cc/verify_center/v1_0_1.Config/Get', {
					key: "center_api_charge_list"
				}).then(res => {
					if(res.data){
						let list = JSON.parse(res.data.config)
						this.apiChargeConfig = list
					}
					
				});
				this.$H.post('http://bp.2cccc.cc/verify_center/v1_0_1.Config/Get', {
					key: "center_highdata_charge_list"
				}).then(res => {
					if(res.data){
						let list = JSON.parse(res.data.config)
						this.highdataChargeConfig = list
					}
					
				});
				this.$H.post('http://bp.2cccc.cc/verify_center/v1_0_1.Config/Get', {
					key: "pay_method_config"
				}).then(res => {
					if(res.data){
						let list = JSON.parse(res.data.config)
						this.pay_ways = list
					}
					
				});
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.t-header {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: 700;
		display: flex;
	}

	.t-body {
		padding: 16px;
		border-bottom: 1px solid #909090;
		font-size: 14px;
		font-weight: normal;
		display: flex;
	}

	.t-item {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.change-item {
		width: 31%;
		height: 80px;
		align-items: center;
		justify-content: space-between;
		position: relative;
		display: flex;
		flex-direction: column;
		background: #CCCCCC;
		border: 1px solid #EAEAEA;
		opacity: 1;
		margin-bottom: 10px;
		margin-top: 10px;
		border-radius: 5px;
		padding: 20px 0px;
		cursor: pointer;
	}

	.change-item-active {
		background-color: #CBDCFC !important;
		border: 1px solid #4264F0 !important;
	}
</style>